import React from 'react';
import PropTypes from 'prop-types';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

function LanguageSelect(props) {
  const { label, value, onChange, error } = props;
  const languageOptions = [
    'English',
    'English (UK)',
    'Spanish',
    'French',
    'French Canadian',
    'German',
    'Italian',
    'Dutch',
    'Polish',
    'Finnish',
    'Norwegian',
    'Danish',
    'Swedish',
    'Icelandic',
    'Russian',
    'Japanese',
/*
    
    'Chinese (Simplified)',
    'Chinese (Traditional)',
    'Korean',
    'Arabic',
    'Hindi',
    'Bengali',
    'Punjabi',
    'Urdu',
    'Turkish',
*/
  ];

  return (
    <FormControl variant="outlined" fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select value={value} onChange={onChange} label={label} error={error} autoWidth>
        {languageOptions.map((language) => (
            <MenuItem key={language} value={language}>
                {language}
            </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

LanguageSelect.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool.isRequired,
};

export default LanguageSelect;